/*
 * Copyright © 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { StrictMode } from "react";
import App from "./App";
import { accessGranted } from "./services/environment";
import BrowserNotice from "./components/Browser/BrowserNotice";
import MaintenancePage from "./containers/Pages/Generic/MaintenancePage/MaintenancePage";
import { createRoot } from "react-dom/client";

const MAINTENANCE_MODE = false;

const startApp = () => {
  const container = document.getElementById("root")!;
  let root = createRoot(container);

  const isUnsupportedBrowser = (): boolean => {
    const ua = navigator.userAgent;

    // IE Check
    const isIE = ua.includes("MSIE") || ua.includes("Trident/");
    if (isIE) {
      return true;
    }

    // Samsung browser check
    if (ua.includes("SamsungBrowser/")) {
      const versionMatch = ua.match(/SamsungBrowser\/([0-9.]+)/);
      if (versionMatch && versionMatch[1]) {
        const majorVersion = parseInt(versionMatch[1].split(".")[0], 10);
        if (majorVersion < 6) {
          return true;
        }
      }
    }

    return false;
  };

  if (isUnsupportedBrowser()) {
    root.render(<BrowserNotice />);
    return;
  }

  if (!accessGranted(window.location.search)) {
    root.render(
      <div>
        <a href="https://www.legalbird.de">Weiter zu Legalbird</a>
      </div>
    );
    return;
  }

  if (MAINTENANCE_MODE) {
    root.render(<MaintenancePage />);
    return;
  }

  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
};

startApp();
